import { render, staticRenderFns } from "./SedangPerbaikan.vue?vue&type=template&id=d46e0fc0"
import script from "./SedangPerbaikan.vue?vue&type=script&lang=js"
export * from "./SedangPerbaikan.vue?vue&type=script&lang=js"
import style0 from "./SedangPerbaikan.vue?vue&type=style&index=0&id=d46e0fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports